<template>
  <div class="language-dialog">
    <div class="language-dialog-content">
      <button
        @click="selectLanguage(key)"
        class="language-option"
        :class="{ 'language-option--active': key === locale }"
        v-for="key in Locales"
        :key="`locale-${key}`"
        type="button"
        :data-test="'header-link-language-' + key"
      >
        <span class="language-option__code">
          {{ key.toUpperCase() }}
        </span>
        <span class="language-option__label">
          {{ $t("languageCode." + key) }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { Locales } from "@/localization/i18n";
import { useLocaleStore } from "@/stores/locale";

const localeStore = useLocaleStore();
const { locale } = useI18n();
const emit = defineEmits<{
  (e: "close-requested"): void;
}>();

function selectLanguage(language: string) {
  localeStore.locale = language;
  emit("close-requested");
}
</script>

<style scoped lang="scss">
.language-dialog {
  z-index: 1000;
}

.language-dialog-content {
  position: relative;
  display: flex;
  gap: 2.4rem;
  min-width: 22rem;
  padding: 1.6rem 2rem 2rem;
  background-color: white;
  border: 0.1rem solid #e3e6ec;
  border-top: 0;
}

.language-dialog-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0.8rem;
  pointer-events: none;

  background: linear-gradient(
    to bottom,
    rgb(0 0 0 / 10%) 0%,
    rgb(0 0 0 / 7%) 10%,
    rgb(0 0 0 / 5%) 25%,
    rgb(0 0 0 / 3.5%) 45%,
    rgb(0 0 0 / 2%) 65%,
    rgb(0 0 0 / 1%) 80%,
    rgb(0 0 0 / 0.7%) 92%,
    rgb(0 0 0 / 0%) 100%
  );
}

.language-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  border: 0;
  background: transparent;
  color: $color-blue-dark;
  cursor: pointer;
  padding: 5px 2px 0 8px;
}

.language-option__code {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.8rem;
  height: 3.8rem;
  background: #f3f4f7;
  font-size: $font-size-base;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.language-option__label {
  font-size: $font-size-base;
  white-space: nowrap;
}

.language-option:hover .language-option__code,
.language-option--active .language-option__code {
  background: #eef6ff;
  color: $color-etBlue;
}

.language-option:hover .language-option__label,
.language-option--active .language-option__label {
  color: $color-etBlue;
}
</style>
